import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { AreaExplorer } from '@/components/widgets/area-explorer'
import { ZipChecker } from '@/components/widgets/zip-checker'

export const ServiceAreaSection: FC = (): ReactNode => {
    return (
        <section id='service-area' className='relative overflow-hidden bg-ink py-24 text-cream md:py-32'>
            <div aria-hidden='true' className='door-grooves pointer-events-none absolute inset-0 opacity-30' />

            <Container className='relative'>
                <AreaExplorer>
                    <SectionHeading
                        layout='stack'
                        tone='light'
                        eyebrow="Where we work"
                        title="Is your street on our route?"
                        description="We cover 8 towns from a single yard on Foundry Street in Riverton. Type your ZIP for a quick answer."
                    />

                    <ZipChecker tone='light' className='mt-8' />
                </AreaExplorer>
            </Container>
        </section>
    )
}
